import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import CustomButton from "../../common-components/button/Button.jsx";
import { useDispatch } from "react-redux";
import { setCurrentStep } from "../../state/reducers/architectureConversion";

function ArchSummary() {
  const dispatch = useDispatch();
  const [sourceStack, setSourceStack] = useState([]);
  const [targetStack, setTargetStack] = useState([]);

  useEffect(() => {
    // Load source and target stack from local storage
    const savedSourceStack = JSON.parse(localStorage.getItem("sourceStack")) || [];
    const savedTargetStack = JSON.parse(localStorage.getItem("targetStack")) || [];
    setSourceStack(savedSourceStack);
    setTargetStack(savedTargetStack);
  }, []);

  const handleNext = () => {
    dispatch(setCurrentStep(6));
  };

  const handleBack = () => {
    dispatch(setCurrentStep(3));
  };

  return (
    <div className="page-wrapper database-conversion-page px-3">
      <Container>
        <Row>
          <Col>
            <h2 className="page-title">Summary</h2>
            <div className="arch-conversation-wrapper">
              <div className="arch-structure-wrapper">
                <div className="upload-structure-wrapper">
                  <h3 className="wrapper-title">Source</h3>
                  <div className="app-details">
                    <Row>
                      <Col md={5} className="arch-summary-title">Source Path</Col>
                      <Col md={7} className="path">C:/Users/123456/Desktop/Legacy_Architecture</Col>
                    </Row>
                    <Row>
                      <Col md={5} className="arch-summary-title">Source Stack</Col>
                      <Col md={7}>
                        <ul>
                          {sourceStack.map((tech, index) => (
                            <li key={index}>{tech}</li>
                          ))}
                        </ul>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="export-structure-wrapper">
                  <h3 className="wrapper-title">Target</h3>
                  <div className="app-details">
                    <Row>
                      <Col md={5} className="arch-summary-title">Source Path</Col>
                      <Col md={7} className="path">C:/Users/123456/Desktop/Legacy_Architecture</Col>
                    </Row>
                    <Row>
                      <Col md={5} className="arch-summary-title">Target Stack</Col>
                      <Col md={7}>
                        <ul>
                          {targetStack.map((tech, index) => (
                            <li key={index}>{tech}</li>
                          ))}
                        </ul>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col className="text-end">
            <CustomButton className="me-2" onClick={handleBack} label="Back" />
            <CustomButton onClick={handleNext} label="Start Conversion" />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ArchSummary;